export const testimonials = [
  {
    id: 1,
    name: "Shantanu Dharmadhikari",
    position: "Administration Manager",
    company: "Jet2 Travels",
    avatar: "SD",
    rating: 5,
    text: "Great experience with 360Customizer. Top-quality products, creative ideas, and a very supportive team.",
    color: "from-purple-400 to-purple-600",
  },
  {
    id: 2,
    name: "Gurpreet Singh Aidhen",
    position: "HR Manager",
    company: "Weikfield",
    avatar: "GA",
    rating: 5,
    text: "Trusted corporate gifting partner. Always on-time delivery, quality products, and very professional.",
    color: "from-green-400 to-green-600",
  },
  {
    id: 3,
    name: "Naveen Kumar",
    position: "HR Manager",
    company: "Forms + surfaces",
    avatar: "NK",
    rating: 5,
    text: "Excellent experience with 360Customizer. Reliable delivery, great service, and high-quality gifts.",
    color: "from-orange-400 to-orange-600",
  },
  {
    id: 5,
    name: "Nira Khair-Godbole",
    position: "Chief Operating Officer",
    company: "LogicalDNA Solutions",
    avatar: "NK",
    rating: 5,
    text: "Nice experience to work with 360Customizer. Quality is good — the best thing is we also got ladies t-shirts with the same branding for our girl gang, unlike other vendors offering only unisex fitting. Delivery was on time even though our order was placed at the last moment during Diwali peak. Communication was great — Nilesh is very soft-spoken, handled all queries patiently, and helped us select items for our gift kit. I would definitely recommend 360Customizer to everyone.",
    color: "from-cyan-400 to-cyan-600",
  },
  {
    id: 6,
    name: "Aishwarya More",
    position: "Senior HR Executive",
    company: "SpryIQ",
    avatar: "AM",
    rating: 5,
    text: "Thank you for the gift hampers. We all loved the products. We will surely love to connect with 360 Customizer in future.",
    color: "from-pink-400 to-pink-600",
  },
  {
    id: 7,
    name: "Monali Pacharne",
    position: "HR Manager",
    company: "Clodura.AI",
    avatar: "MP",
    rating: 5,
    text: "Awesome experience with 360Customizer. Jackets were top-quality, perfect fit, loved by everyone, with smooth coordination and on-time delivery.",
    color: "from-teal-400 to-teal-600",
  },
  {
    id: 8,
    name: "Tanya Bose",
    position: "",
    company: "Tata Bluescope Steel",
    avatar: "TB",
    rating: 0,
    text: "Wonderful work! We are happy to see our business partners grow along with us. Let's connect on similar initiatives in the upcoming days.",
    color: "from-amber-400 to-amber-600",
  },
  {
    id: 9,
    name: "Nikita Yadav",
    position: "",
    company: "TManilitics b2b",
    avatar: "NY",
    rating: 0,
    text: "Thanks so much for the support extended. We appreciate the efforts that the 360Customizer team puts in always!",
    color: "from-lime-400 to-lime-600",
  },
  {
    id: 10,
    name: "Atharva Kamble",
    position: "",
    company: "",
    avatar: "AK",
    rating: 5,
    text: "Great service, great product.. thank you Ankur and Asmita for the hampers, they are amazing and just the way we expected them to be!",
    color: "from-fuchsia-400 to-fuchsia-600",
  },
  {
    id: 11,
    name: "Atul Samarth",
    position: "",
    company: "Laxmi Narayan Consultancy",
    avatar: "AS",
    rating: 5,
    text: "This company has great expertise knowledge in this field plus Mr. Nilesh Nanaware shares his expertise without any hesitation which boosts morale. Great delivery and printing — actually impressive. A happy client's view.",
    color: "from-emerald-400 to-emerald-600",
  },
  {
    id: 12,
    name: "Durva Dighe",
    position: "",
    company: "",
    avatar: "DD",
    rating: 5,
    text: "Prompt services and amazing designs. They customize as per your requirement and the quality is up to the mark. Totally happy with the products and team efficiency.",
    color: "from-indigo-400 to-indigo-600",
  },
  {
    id: 13,
    name: "Vanashree Chowdhury",
    position: "",
    company: "Elephant and Co.",
    avatar: "VC",
    rating: 0,
    text: "360Customizer is my go-to place for customised corporate merchandise. Always received the best of service and products at a reasonable price. Mr. Nilesh is very professional and provides excellent service. Highly recommend!",
    color: "from-red-400 to-red-600",
  },
  {
    id: 14,
    name: "Sushant Rananaware",
    position: "",
    company: "Maruti",
    avatar: "SR",
    rating: 0,
    text: "Excellent quality, amazing designs, affordable prices, helpful customer support and very fast dispatch and delivery.",
    color: "from-red-400 to-red-600",
  },
  {
    id: 15,
    name: "Arundhati Jagtap",
    position: "",
    company: "",
    avatar: "AJ",
    rating: 5,
    text: "Good service and quality products. Professional team.",
    color: "from-rose-400 to-rose-600",
  },
  {
    id: 16,
    name: "Renuka Hatekar",
    position: "",
    company: "",
    avatar: "RH",
    rating: 5,
    text: "T-shirt quality is very good. We ordered for a kid — very comfortable and the printing quality is superb. Thank you!",
    color: "from-sky-400 to-sky-600",
  },
  {
    id: 17,
    name: "Ruchira Ekbote",
    position: "",
    company: "",
    avatar: "RE",
    rating: 5,
    text: "I am very happy with the service, quality, and professionalism.",
    color: "from-violet-400 to-violet-600",
  },
  {
    id: 18,
    name: "Nira Khair-Godbole",
    position: "Chief Operating Officer",
    company: "LogicalDNA Solutions",
    avatar: "NK",
    rating: 5,
    text: "Nice experience to work with 360Customizer. Quality is good — the best thing is we also got ladies t-shirts with the same branding for our girl gang, unlike other vendors offering only unisex fitting. Delivery was on time even though our order was placed at the last moment during Diwali peak. Communication was great — Nilesh is very soft-spoken, handled all queries patiently, and helped us select items for our gift kit. I would definitely recommend 360Customizer to everyone.",
    color: "from-cyan-400 to-cyan-600",
  },
];
